module.exports = __webpack_public_path__ + "img/bq.59109a05.svg";